import { render } from "./EndpointIconMap.vue?vue&type=template&id=7231bc40&lang=pug"
const script = {}
script.render = render

export default script